/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { LanguageFormValues } from "src/models/Language.model";
import LanguageForm from "../Layout/LanguageForm";
import { useAddLanguageMutation } from "src/services/LanguageServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddLanguageFormWrapper = ({ onClose }: Props) => {
  const [addLanguage] = useAddLanguageMutation();
  // Form Initial Values
  const initialValues: LanguageFormValues = {
    languageName: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    languageName: string().required("Please enter language"),
  });

  // Handle Submit
  const handleSubmit = (
    values: LanguageFormValues,
    { setSubmitting, resetForm }: FormikHelpers<LanguageFormValues>
  ) => {
    setTimeout(() => {
      addLanguage(values).then((res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      });
    }, 1000);
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <LanguageForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddLanguageFormWrapper;
